<div class="col-xl-4 col-lg-6 col-md-6 grid-item case5">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/mobile-apps/01.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Compete For Home</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case5">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/mobile-apps/05.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">Team Cohort360</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case5">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/mobile-apps/02.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">XT Social</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case5">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/mobile-apps/03.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">XT-Trading</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>
<div class="col-xl-4 col-lg-6 col-md-6 grid-item case5">
    <div class="case-box style2 case-box-shadow inner-style1 position-relative">
        <div class="case-img global-img">
            <img src="assets/img/portfolio/mobile-apps/04.jpg" alt="case image" />
            <a routerLink="/services" class="icon-btn"><i class="fa-light fa-arrow-right-long"></i></a>
        </div>
        <div class="case-content">
            <div class="media-left">
                <h4 class="box-title">
                    <a routerLink="/services">XT Food APP</a>
                </h4>
                <span class="case-subtitle">Design & Development</span>
            </div>
        </div>
        <div class="case-action">
            <a routerLink="/services" class="case-btn">
                <i class="fa-light fa-arrow-right-long"></i>
            </a>
        </div>
    </div>
</div>